import { LoadableStatus } from '../mobx-utils';
import { useEffect, useState } from 'react';
import { useStore } from '../core/store';

import { getDestinationGreeting } from '../utils/get-destination-greeting';

export function useBookingInformation() {
  const { BookingStore } = useStore();

  const { data, status } = BookingStore.booking;

  const [config, setConfig] = useState({
    bookingId: null,
    hotelName: null,
    location: null,
    salutation: null,
    travelDate: null,
    traveler: null,
    destinationAirport: null,
    // TODO: add airports 🚀
  });

  useEffect(() => {
    if (status === LoadableStatus.done) {
      setConfig({
        bookingId: data?.id,
        hotelName: data?.hotelName,
        location: data?.name,
        salutation:
          data?.hotels[0] &&
          getDestinationGreeting(
            'wartet auf Sie',
            'warten auf Sie',
            data?.travellers[0].salutation,
            data?.travellers[0].lastname,
            data?.hotels[0]?.country,
          ),
        travelDate: `${data.startDate} - ${data?.endDate}`,
        traveler: `${data?.travellers?.length} Reisende`,
        destinationAirport: data?.flights[0]?.arrivalAirport,
        // TODO: add airports 🚀
      });
    }
  }, [status]);

  return config;
}
